import { EditableTransactionKeys, FullMoneyflowType } from 'interfaces/moneyflow'
import { SortingProp } from 'interfaces/table'

export const RECENT_TRANSACTIONS_LIMIT = 10

export const TOTAL_SPENDING_TRACKER_CATEGORY_NAME = 'Total Spending'
export const TOTAL_INCOME_TRACKER_CATEGORY_NAME = 'Total Income'

export const MONEYFLOW_LIMIT_TYPE: Record<FullMoneyflowType, string> = {
  spending: 'your limit',
  income: 'your goal',
  transactions: '',
}

export const TRACKER_LIMIT_TYPE: Record<FullMoneyflowType, string> = {
  spending: 'limit',
  income: 'goal',
  transactions: '',
}

export const DEFAULT_TRANSACTIONS_SORTING: SortingProp = {
  direction: 'desc',
  columnName: 'date',
}

export const EMPTY_PIE_CHART_LABEL = 'No transactions found'

export const EDITABLE_TRANSACTION_KEYS: EditableTransactionKeys[] = ['amount', 'date', 'description', 'category']
